module.exports = __webpack_public_path__ + "static/storytimeMobile-2f558022cf89eed2434c21e6ba4415d5.jpg";